import { WrappedUserDetailPage } from './lib/UserDetail';
export * from './lib/components';
export default WrappedUserDetailPage;
